
import { IViewTicketClaimLinkRecord, ViewTicketClaimLinkClassProxy, viewTicketClaimLinkClassProxy } from '@src/framework/view/ticket/ViewTicketClaimLink';
import ListView from '@framework/forms/listview';

import '@framework/crud/ticket/ClaimLinkCrud'; // Ezt ne távolítsd el mert akkor a hülye webpack kioptimizálja!

export default class ClaimLinkListView extends ListView<IViewTicketClaimLinkRecord> {
    public getViewClassProxy(): ViewTicketClaimLinkClassProxy { return viewTicketClaimLinkClassProxy; }
}
